import { Route, Routes } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import Layout from './components/Layout.jsx';
import WorkspacePage from './pages/WorkspacePage.jsx';
import MessagesPage from './pages/MessagesPage.jsx';

export default function App() {
    return (
        <>
            <SignedOut>
                <div className="auth-screen">
                    <SignIn />
                </div>
            </SignedOut>

            <SignedIn>
                <Routes>
                    <Route element={<Layout />}>
                        <Route index element={<WorkspacePage />} />
                        <Route path="messages/:companyId?" element={<MessagesPage />} />
                    </Route>
                </Routes>
            </SignedIn>
        </>
    );
}
